import { render } from "./HeaderMessengerButton.vue?vue&type=template&id=59036274&scoped=true&ts=true"
import script from "./HeaderMessengerButton.vue?vue&type=script&lang=ts"
export * from "./HeaderMessengerButton.vue?vue&type=script&lang=ts"

import "./HeaderMessengerButton.vue?vue&type=style&index=0&id=59036274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59036274"]])

export default __exports__